import {useContext} from 'react'
import {ThirdPartyContext} from '@consteed/frontend/contexts/ThirdPartyContext'

const EPSILON = Number.EPSILON || Math.pow(2, -52)
const PRECISION_FACTOR = 100

const round = (price) => {
    return Math.round(price * PRECISION_FACTOR * (1 + EPSILON)) / PRECISION_FACTOR
}

const getNetTotal = (lineItemCntr) => {
    const orderTotal = lineItemCntr.orderTotal || lineItemCntr.productTotal || 0
    const isGross = lineItemCntr.taxation === 'gross'
    const orderNetTotal = isGross ? orderTotal - (lineItemCntr.taxTotal || 0) : orderTotal
    return round(orderNetTotal)
}

const getEventItem = ({index, item, isGross}) => {
    const priceFullQuantity = item.priceAfterItemDiscount || item.price || 0
    const taxFullQuantity = isGross ? item.adjustedTax || item.tax || 0 : 0
    const quantity = item.quantity || 1
    const priceToRound = (priceFullQuantity - taxFullQuantity) / quantity
    const eventItem = {
        item_id: item.productId,
        item_name: item.productName,
        price: round(priceToRound),
        quantity: quantity
    }
    if (typeof index !== 'undefined') {
        eventItem.index = index
    }
    return eventItem
}

const getEventItems = (lineItemCntr) => {
    const isGross = lineItemCntr?.taxation === 'gross'
    return lineItemCntr?.productItems?.map((item, index) => {
        return getEventItem({index, item, isGross})
    })
}

const calculateNetPrice = ({price, taxRate}) => {
    return round(price / (1 + taxRate))
}

export default function useTracking() {
    const {eventTracking} = useContext(ThirdPartyContext)

    return {eventTracking, getEventItems, getEventItem, getNetTotal, round, calculateNetPrice}
}
